// extracted by mini-css-extract-plugin
export default {"black__gradient":"styles_black__gradient__f44EF","section__wave":"styles_section__wave__lHydZ"};